import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

import { ClarityIcons, vmIcon, userIcon, logoutIcon, pencilIcon, plusCircleIcon, noteIcon, minusCircleIcon, downloadIcon, playIcon, stopIcon, uploadCloudIcon, trashIcon, angleIcon, refreshIcon, checkIcon, eyeIcon } from '@cds/core/icon';
import { appConfig } from './app/app.config';
import '@cds/core/badge/register.js'; 
import '@cds/core/icon/register.js';  
import '@cds/core/progress-circle/register.js';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe);

ClarityIcons.addIcons(vmIcon, userIcon, logoutIcon, pencilIcon, plusCircleIcon, minusCircleIcon, downloadIcon, noteIcon, playIcon, stopIcon, uploadCloudIcon, trashIcon, angleIcon, refreshIcon, checkIcon, eyeIcon);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
